import { Header } from "../../header/Header";
import { Footer } from "../footer/Footer";
import { Joinus } from "../joinus/Joinus";
import { ServicesShowcase } from "../service/ServicesShowcase";
import a3 from "../../assets/a3.jpg";

export const Individual = () => {
  return (
    <div>
      <Header />

      <section className="relative overflow-hidden bg-gradient-to-br from-brand-900 via-brand-800 to-sea-800 py-20 sm:py-24">
        <div className="pointer-events-none absolute -left-20 top-0 h-64 w-64 rounded-full bg-white/10 blur-3xl" />
        <div className="pointer-events-none absolute -right-20 bottom-0 h-64 w-64 rounded-full bg-sea-400/20 blur-3xl" />
        <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-6">
          <span className="text-xs font-bold uppercase tracking-[0.3em] text-brand-200">
            Our Services
          </span>
          <h1 className="mt-4 font-display text-5xl font-semibold text-white sm:text-6xl">
            Individual Therapy
          </h1>
        </div>
      </section>

      <section className="bg-white py-20 sm:py-24">
        <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8">
          <div className="relative mx-auto w-full max-w-lg">
            <div className="absolute inset-0 -rotate-2 rounded-[2rem] bg-brand-100" />
            <img
              src={a3}
              alt="Individual therapy session"
              className="relative w-full rounded-[2rem] object-cover shadow-soft"
            />
          </div>
          <div>
            <h2 className="font-display text-3xl font-semibold text-slate-900 sm:text-4xl">
              A safe space that's all yours
            </h2>
            <p className="mt-6 text-lg leading-relaxed text-slate-600">
              The struggle to manage behaviour and lifestyle along with
              overthinking thoughts and work life balance is pretty common.
              Individual therapy is centred around the needs and concerns of a
              single individual it provides a safe and confidential space for
              individuals to explore and address their personal issues,
              emotions and mental health concerns. The primary goal is to help
              the individual gain inside into their thoughts feelings and
              behaviour. The individual therapy also helps to develop I am
              stills to manage and overcome challenges.
            </p>
          </div>
        </div>
      </section>

      <ServicesShowcase />
      <Joinus />
      <Footer />
    </div>
  );
};
